import React, { isValidElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@modulor/react';
import Local from '../Local/Local';
import Skeleton from '../Skeleton/Skeleton';
import { LinkWithAnalytics } from '../Link/Link';
import { DivWithAnalytics } from '../AnalyticsComponents/DivWithAnalytics';
import { ReactComponent as ForwardIcon } from '../../AppSCCOM/assets/icons/forward.svg';
import { getDataTestAttrs } from '../../utils/testing-locators';
import {
  HEADING,
  HEADING_TITLE,
  HEADING_LINK,
} from '../../constants/dataTestIds';
import styles from './Heading.module.css';
import { useIsSSCOMBrand } from '../../hooks/useIsSSCOMBrand';

const Heading = ({
  link,
  isLoading,
  children,
  className,
  additionalLayerData,
  eventAction,
  analyticsData,
  onClick,
}) => {
  const isSCCOM = useIsSSCOMBrand();

  return children ? (
    <div
      className={classNames(
        styles.component_ig,
        className,
        isSCCOM && styles.component_indent
      )}
      {...getDataTestAttrs(HEADING)}
    >
      {isLoading ? (
        <Skeleton className={styles.skeleton_ig} />
      ) : (
        <>
          {link ? (
            <LinkWithAnalytics
              to={link}
              className={classNames(styles.title_ig, styles.short_ig)}
              analyticsData={analyticsData}
              dataLayerEventData={{
                eventAction: eventAction,
                ...(additionalLayerData || {}),
              }}
              {...getDataTestAttrs(HEADING_TITLE)}
            >
              {children}
            </LinkWithAnalytics>
          ) : (
            <h2
              className={styles.title_ig}
              {...getDataTestAttrs(HEADING_TITLE)}
            >
              {children}
            </h2>
          )}

          {link && (
            <>
              {isValidElement(link) ? (
                link
              ) : (
                <LinkWithAnalytics
                  to={link}
                  className={styles.link_ig}
                  analyticsData={analyticsData}
                  dataLayerEventData={{
                    eventAction: eventAction,
                    ...(additionalLayerData || {}),
                  }}
                  {...getDataTestAttrs(HEADING_LINK)}
                >
                  {isSCCOM ? (
                    <ForwardIcon className={styles.icon_ig} />
                  ) : (
                    <>
                      <Local>Show all</Local>
                      <Icon name="chevron_right" className={styles.icon_ig} />
                    </>
                  )}
                </LinkWithAnalytics>
              )}
            </>
          )}

          {onClick && (
            <DivWithAnalytics
              className={styles.link_ig}
              onClick={onClick}
              dataLayerEventData={{
                eventAction: eventAction,
                ...(additionalLayerData || {}),
              }}
              analyticsData={analyticsData}
              {...getDataTestAttrs(HEADING_LINK)}
            >
              <Local>Show all</Local>
              <Icon name="chevron_right" className={styles.icon_ig} />
            </DivWithAnalytics>
          )}
        </>
      )}
    </div>
  ) : null;
};

Heading.propTypes = {
  link: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]),
  isLoading: PropTypes.bool,
  analyticsData: PropTypes.shape({
    screen_area_detail: PropTypes.string,
    schema: PropTypes.string,
    name: PropTypes.string,
    section_index: PropTypes.number,
    screen_name: PropTypes.string,
    screen_area: PropTypes.string,
    event_detail: PropTypes.string,
  }),
};

Heading.defaultProps = {
  link: '',
  isLoading: false,
  analyticsData: {},
};

export default Heading;
